import { render, staticRenderFns } from "./CustomDialogWrapper.vue?vue&type=template&id=a96fc278"
import script from "./CustomDialogWrapper.vue?vue&type=script&lang=js"
export * from "./CustomDialogWrapper.vue?vue&type=script&lang=js"
import style0 from "./CustomDialogWrapper.vue?vue&type=style&index=0&id=a96fc278&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports